<template>
        <!-- Navbar -->
        <div ref="topbar" class="fixed-top">
            <b-navbar id="navbar" class="main-navbar border-bottom" toggleable="lg" type="light" variant="primary">
                <div class="container px-sm-3">
                    <b-navbar-brand :to="{name: 'home'}">
                        <img src="https://cdn.studiesweekly.com/logo/2017+SW_horiz-white.png" alt="logo">
                    </b-navbar-brand>
                    <h5 class="text-light"><slot name="header">Adoption</slot></h5>
                </div>
            </b-navbar>
        </div>
    </div>
</template>

<script>
export default {
    name: "AdoptionNavbar"
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_colors.scss";

@media (max-width: 1199px) { .main-navbar { .navbar-brand > img { width: 210px; } } }
@media (max-width: 991px ) { .main-navbar { .navbar-brand > img { width: 200px; } } }
@media (max-width: 767px ) { .main-navbar { .navbar-brand > img { width: 190px; } } }

.main-navbar {
    .navbar-brand > img {
        width: 220px;
        height: auto;
    }

    .navbar-nav {
        .nav-link,
        .nav-link:focus {
            color: $dark;
        }

        .nav-link:hover {
            color: $primary;
        }

        .nav-link.active {
            color: $primary;
        }

        .badge {
            font-size: 100%;
        }
    }
}
</style>